import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-[#F7F5F0] py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-16 h-16 rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-md bg-white grid place-items-center">
                <img
                  src="https://customer-assets.emergentagent.com/job_foreclosure-leads/artifacts/iyaa4h8h_American%20Asset%20logo-01.png"
                  alt="American Asset Recovery Agency"
                  className="w-full h-full object-contain p-1"
                />
              </div>
              <div className="leading-tight">
                <p className="font-serif-display text-xl">American Asset</p>
                <p className="font-serif-display text-xl text-[#FF008F] -mt-1">Recovery Agency</p>
              </div>
            </div>
            <p className="mt-5 text-sm text-[#F7F5F0]/70 max-w-sm">
              Helping families across America reclaim the surplus funds they're rightfully owed after foreclosure.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#FF008F]/80 mb-4">Quick Links</p>
            <ul className="space-y-2 text-sm">
              <li><a href="/#about" className="hover:text-[#FF008F]">What We Do</a></li>
              <li><a href="/#process" className="hover:text-[#FF008F]">Our Process</a></li>
              <li><a href="/team" className="hover:text-[#FF008F]">Meet the Team</a></li>
              <li><a href="/blog" className="hover:text-[#FF008F]">Blog</a></li>
              <li><a href="/#faq" className="hover:text-[#FF008F]">FAQ</a></li>
              <li><a href="/#claim" className="hover:text-[#FF008F]">Free Claim Check</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-[#FF008F]/80 mb-4">Contact</p>
            <ul className="space-y-2 text-sm">
              <li><a href="tel:+18335359505" className="hover:text-[#FF008F]">1-833-535-9505</a></li>
              <li><a href="mailto:recover@americanassetrecoveryagency.com" className="hover:text-[#FF008F] break-all">recover@americanassetrecoveryagency.com</a></li>
              <li className="text-[#F7F5F0]/60">Based in Southwest Florida — serving all 48 states</li>
              <li>Mon–Fri, 9am – 4pm ET</li>
            </ul>
            <Link to="/admin/login" className="inline-block mt-6 text-xs text-[#F7F5F0]/40 hover:text-[#FF008F]" data-testid="footer-admin-link">Admin Login</Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#F7F5F0]/10 grid md:grid-cols-2 gap-4 text-xs text-[#F7F5F0]/50">
          <p>© {new Date().getFullYear()} American Asset Recovery Agency. All rights reserved.</p>
          <div className="md:text-right space-x-4">
            <Link to="/privacy" className="hover:text-[#FF008F]" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#FF008F]" data-testid="footer-terms-link">Terms of Service</Link>
          </div>
        </div>
        <p className="mt-4 text-xs text-[#F7F5F0]/40 max-w-3xl">
          This website is for informational purposes only and is not legal advice. Results vary by case.
        </p>
      </div>
    </footer>
  );
}
